import { gql, QueryHookOptions, TypedDocumentNode } from "@apollo/client";

import {
  GetCustomerQuery,
  GetCustomerQueryVariables,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { useFetchQuery } from "src/graphql/utils";
import { mapToCustomer } from "src/mappers/customer.mappers";

import { customerFragment } from "../../fragments/CustomerFragment";

export const getCustomerByIdQuery = gql`
  query GetCustomer($id: ID!) {
    customer(id: $id) {
      ...CustomerFragment
    }
  }
  ${customerFragment}
` as TypedDocumentNode<GetCustomerQuery, GetCustomerQueryVariables>;

export const useGetCustomerByIdQuery = (
  options: QueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>
) => {
  return useFetchQuery(getCustomerByIdQuery, {
    toData: (data) => {
      if (!data?.customer) return null;

      return {
        ...mapToCustomer(data.customer),
      };
    },
    isEmpty: (data) => !data?.customer,
    queryOptions: options,
    uiErrors: {
      fetchError: "FETCH-CUSTOMER-ERROR",
    },
  });
};
